const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  placeInfo: state => state.placeCode.placeInfo,
  suspectedCaseReportAddInfo:state => state.suspectedCaseReport.suspectedCaseReportAddInfo,
  pet: state => state.addReserveInfo.pet,
  petHospital: state => state.addReserveInfo.petHospital,
  vaccineInfo: state => state.addReserveInfo.vaccineInfo,
  antibodyInfo: state => state.addReserveInfo.antibodyInfo,
  geneInfo: state => state.addReserveInfo.geneInfo,
  recordDate: state => state.addReserveInfo.recordDate,
  petInfo: state => state.myPet.petInfo,
  petBreed: state => state.myPet.petBreed,
}
export default getters
